let service = function ($rootScope, Http) {
	"ngInject";

	this.get = (id) => Http.get('/v1/category/'+id, false);
	this.all = (data) => Http.get('/v1/category');
	this.complete = () => Http.get('/v1/category/complete');
};

export default service;




// WEBPACK FOOTER //
// ./app/shared/services/category.service.js